import { DOCUMENT } from '@angular/common';
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Inject,
  HostListener,
  AfterViewInit,
  Renderer2,
  Injector,
  HostBinding,
  TemplateRef,
  OnDestroy
} from '@angular/core';
import {
  NavigationStart,
  Router,
  RoutesRecognized,
  NavigationEnd
} from '@angular/router';
import { BehaviorSubject, Subject, Subscription, firstValueFrom } from 'rxjs';
import { API_URLS } from '@core/api-url.enum';
import { ApiCallService } from '@services/api-call.service';
import { AuthService } from '@core/auth.service';
import { Application } from '@enums/application.enums';
import { CommonService } from '@modules/shared/services/common.service';
import {
  screenSizeType,
  WhiteLabelConfig,
  UserData
} from '@models/common.interface';
import { Store } from '@ngrx/store';
import * as fromUserProfile from '@modules/shared/user-profile.reducer';
import * as userProfileAction from '@modules/shared/user-profile.action';
import { filter, pairwise, takeUntil, debounceTime, take } from 'rxjs/operators';
import { CoreService } from '@services/core.service';
import { ChatService } from '@services/chat.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
  ApplicationStatusEnums,
  PERMISSION_TYPE
} from '@shared/enums/common.enum';
import { FirebaseService } from '@modules/shared/services/firebase.service';
import { PERMISSION_KEYS } from '@modules/shared/constants/permissions.contant';
import {
  HEADER_LABELS,
  TOPFAN_HEADER_DEFAULT_LOGO_URLS
} from '@constants/constant';
import { environment } from '@environments/environment';
import { HeaderFooterStateService } from '@modules/shared/services/header-footer-state.service';
import { fromEvent } from 'rxjs';
import { WalletService } from '@wallet/service/wallet.service';
import { isReservedFrontUrlSegment } from '@constants/reserved-front-urls';
import { ROUTE_PATHS } from '@constants/routes';
import { isPublicSubPagePath } from '@modules/sub-page-view/sub-page-view.constants';
import { CREATORS_CONST } from '@modules/creators-home/constants/creatorsConstants';
import { AUTH_CONSTANTS, PRO_HEADER_NAV } from '@modules/auth/constants/authConstants';
import { IndexedDbService } from '@services/indexed-db.service';
// import { CacheService } from '@shared/services/cache.service';
import { ADVERTISEMENT_CONST } from '@modules/advertisement-home/constants/constant';
import { ApiCacheService, CacheTypes } from '@core/cache/api-cache.service';
import { MarketingPageStateService } from '@modules/shared/services/marketing-page-state.service';
import { SIDEBAR_TABS } from '@modules/shared/constants/tab-approval.constant';
import { PAGE_COMPARISONS, PAGE_FEATURES } from '@modules/promotional/promotional/featured-categories/featured-categories.constants';
import { MARKETING_PAGE_DATA } from '@constants/marketing-page-data';
import { MARKETING_PRO_PAGE_DATA } from '@constants/marketing-pro-page-data';
import { COMPARISON_PAGE_DATA } from '@constants/comparison-page-data';

// Public legal / informational routes
const LEGAL_INFORMATIVE_PATH_PREFIXES: readonly string[] = [
  '/privacy-policy',
  '/terms-conditions',
  '/terms-of-service',
  '/contact-us',
  '/request-demo',
  '/schedule-a-demo',
  '/about',
  '/pricing',
  '/help-faq',
  '/unsubscribe-instruction',
  '/unsubscribe/newsletter',
  '/imported/opt-out'
];

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('userTypeSelectionModal') userTypeSelectionModal;
  isSearchRes = false;
  isSearching = false;
  searchClass: String;
  isActionButton = new BehaviorSubject<boolean>(true);
  isActionButton$ = this.isActionButton.asObservable();
  lineRemoveClass = '';
  isSearch = false;
  isLogin = false;
  isLoginShow = false;
  backgroundColor: string | null = null;
  themeColor: string | null = null;
  isHeaderVisible = true;
  backBtnDetails = null;
  isAtProfile = false;
  isAtProfileByUrl = false;
  isAtDashboardPage = false;
  profilePageUser = null;
  isMarketingPageVisible = false;
  isPromotionalHome = false;
  userProfileData = {} as any;
  mobileHideClass: string;
  whiteLabelConfig: WhiteLabelConfig;
  headerWithoutLogin: string;
  isHeaderOpen: boolean;
  isSearchBarOpen = false;
  userBlockList = [];
  private readonly subscriptionList: Subscription[] = [];
  chatService: ChatService;
  whitelabelUserData;
  intervalItem = null as any;
  isLogout = false;
  messageCount = '';
  scrSize = 1220;
  isLogedIn;
  isHidden = false;
  isWhitelabel: boolean;
  screenSize: screenSizeType = {
    desktop: Application.NINE_HUNDRED_NINETY_TWO as number,
    mobile: Application.NINE_HUNDRED_NINETY_TWO as number
  };
  applicationStatusEnums = ApplicationStatusEnums;
  permissionKeys = PERMISSION_KEYS;
  private destroy$ = new Subject<void>();
  headerLabels = HEADER_LABELS;
  isAdminAccess = false;
  PERMISSION_TYPE = PERMISSION_TYPE;
  isAtHomePage: boolean = false;
  isAtCreatorHomePage: Boolean = false;
  isAtAuthLoginPage = false;
  isAtAuthSignupPage = false;
  isAtAuthVerifyByOtpPage = false;
  isAtAdvertisementHomePage: Boolean = false;
  isLegalInformativePage = false;
  isArticlePostDetailPath = false;
  isScrolling: boolean = false;
  ROUTE_PATHS = ROUTE_PATHS;
  ADVERTISEMENT_CONST = ADVERTISEMENT_CONST;
  currentTheme: string = Application.THEME_DARK;
  @ViewChild('searchInput') searchInput: ElementRef;
  private headerStateSubscription: Subscription;
  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    if (this.cs.isBrowser) {
      if (!this.backgroundColor) {
        const element = this.document.querySelector('.header') as HTMLElement;
        if (window.pageYOffset >= Number(Application.TEN)) {
          element?.classList.add('header-inverse');
        } else {
          element?.classList.remove('header-inverse');
        }
      }
      this.isScrolling = window.scrollY > 0;
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    if (this.cs.isBrowser) {
      const target = event.target as Window;
      this.scrSize = target.innerWidth;
    }
  }
  @HostBinding('style.--custom-theme-color') get cssVariable() {
    return this.themeColor;
  }
  @HostBinding('style.--custom-background-color') get cssBgVariable() {
    return this.backgroundColor;
  }

  @ViewChild('creatorsRequirementModal') creatorsRequirementModal;
  @ViewChild('bookDemoModal', { static: true })
  bookDemoModal: TemplateRef<any>;
  modalRef: BsModalRef;
  top: number;
  SIDEBAR_TABS = SIDEBAR_TABS;

  // services Instances
  private readonly acs: ApiCallService;
  public readonly cs: CommonService;
  public authService: AuthService;
  private readonly coreService: CoreService;
  originalDelegateAccessList = [];
  isWhiteLabelDataLoading = false; // Set to false initially to prevent header flickering
  CREATORS_CONST = CREATORS_CONST;
  AUTH_CONSTANTS = AUTH_CONSTANTS;
  PAGE_FEATURES = PAGE_FEATURES;
  PAGE_COMPARISONS = PAGE_COMPARISONS;
  isFeaturesDropdownOpen = false;
  isCompareDropdownOpen = false;
  isMarketingKebabMenuOpen = false;
  isVerticalsDropdownOpen = false;
  isPlatformDropdownOpen = false;
  isAtProPage = false;
  isAtProHomePage = false;
  PRO_HEADER_NAV = PRO_HEADER_NAV;

  constructor(
    private readonly router: Router,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly store: Store<fromUserProfile.UserProfileState>,
    private readonly renderer: Renderer2,
    private readonly el: ElementRef,
    _injector: Injector,
    private readonly modalService: BsModalService,
    private firebaseService: FirebaseService,
    private headerFooterStateService: HeaderFooterStateService,
    private readonly commonService: CommonService,
    private readonly walletService: WalletService,
    private indexedDbService: IndexedDbService,
    // private cacheService: CacheService,
    private apiCacheService: ApiCacheService,
    private marketingPageStateService: MarketingPageStateService
  ) {
    this.cs = _injector.get<CommonService>(CommonService);
    this.acs = _injector.get<ApiCallService>(ApiCallService);
    this.authService = _injector.get<AuthService>(AuthService);
    this.coreService = _injector.get<CoreService>(CoreService);
    this.chatService = _injector.get<ChatService>(ChatService);
    if (this.cs.isBrowser) {
      this.scrSize = window.innerWidth;
      window.onblur = () => {
        this.isHidden = true;
      };

      window.onfocus = () => {
        this.isHidden = false;
      };
      fromEvent(window, 'scroll')
        .pipe(debounceTime(100))
        .subscribe(() => this.onWindowScroll());
      this.routerState();
    }
     this.runInitialFunctions();
    this.isHeaderVisible = this.headerFooterStateService.stateSubject.value.isHeaderVisible;
  }

  /** Updates header flags from current router URL. Called in ngOnInit so prerender/SSR use correct URL. */
  private updateRouteBasedFlags(): void {
    const path = this.router.url?.split('?')?.[0] ?? '';
    this.isAtHomePage = path === '/' && !environment.whiteLabelConfig;
    this.isAtCreatorHomePage = path === '/creators' || path === '/creator';
    this.isAtProHomePage = path === '/pro';
    this.isAtAdvertisementHomePage = path === ROUTE_PATHS.ADVERTISE_WITH_US;
    this.isAtAuthLoginPage = path === ROUTE_PATHS.AUTH_LOGIN;
    this.isAtAuthSignupPage = path === ROUTE_PATHS.AUTH_SIGNUP;
    this.isAtAuthVerifyByOtpPage = path.startsWith(ROUTE_PATHS.AUTH_VERIFY_BY_OTP);
    this.isLegalInformativePage = LEGAL_INFORMATIVE_PATH_PREFIXES.some(
      (p) => path === p || path.startsWith(`${p}/`)
    );
    this.isAtDashboardPage = path.startsWith('/dashboard');
    const segments = path.split('/').filter(Boolean);
    this.isAtProfileByUrl =
      segments.length === Application.ONE &&
      !isReservedFrontUrlSegment(segments[0] ?? '') &&
      !isPublicSubPagePath(path);
    this.isArticlePostDetailPath =
      segments[0] === ROUTE_PATHS.POST && segments[2] === 'article';
  }

  runInitialFunctions() {
    if (this.authService.isAuthenticated()) {
      this.userProfile();
      this.getFollowers();
      if (!this.isHidden) {
        this.userNotifications();
        this.getMessageCount();
      }
    }
    this.updateRouteBasedFlags();
    this.isWhitelabel = this.authService.isWhiteLabelWebsite();
    if (this.cs.isBrowser) {
      this.isAdminAccess = !!this.authService.userContext?.fm_user;
      if (this.isAdminAccess || this.authService.isWhiteLabelPreview) {
        this.document.body.classList.add('admin-access');
      }
      if (this.authService.isAuthenticated()) {
        this.intervalItem = setInterval(
          () => {
            try {
              if (!this.authService.isAuthenticated()) {
                clearInterval(this.intervalItem);
              }
              if (
                this.cs.isBrowser &&
                window?.navigator?.onLine &&
                !this.isHidden
              ) {
                this.userNotifications();
              }
            } catch (error) {
              console.error('Error in notification interval:', error);
              clearInterval(this.intervalItem);
            }
          },
          Application.ONE_THOUSAND * (Application.SIXTY * Application.TWO)
        );
      }
      this.isLogedIn = this.authService.isAuthenticated();
      const config = this.cs.getWhiteLabelConfiguration();
      if (config) {
        this.whitelabelUserData = config.user;
        this.whiteLabelConfig = config.data.whiteLabel;
        this.isWhiteLabelDataLoading = false;
      }
      this.isLogedIn = this.authService.isAuthenticated();
      const sub = this.cs.userBlockListUpdated.subscribe((res) => {
        if (res) {
          this.fetchUserBlockedList();
        }
      });
      this.subscriptionList.push(sub);
      if (this.authService.isAuthenticated()) {
        this.fetchUserBlockedList();
      }
    }else{
        const config = this.cs.getWhiteLabelConfiguration();
        if(config){
          this.whitelabelUserData = config.user;
          this.whiteLabelConfig = config.data.whiteLabel;
          this.isWhiteLabelDataLoading = false;
        }
    }
  }

  ngOnInit(): void {
    // Set route-based flags from current URL so prerender/SSR get correct value
    // (routerState() only runs in browser, so SSR would otherwise use constructor-time URL)
    this.updateRouteBasedFlags();

    if (!this.cs.isBrowser) {
      this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd),
        take(1),
        takeUntil(this.destroy$)
      ).subscribe(() => {
        this.updateRouteBasedFlags();
      });
    }

    this.headerStateSubscription =
      this.headerFooterStateService.stateSubject
        .pipe(takeUntil(this.destroy$))
        .subscribe((state) => {
        this.isSearch = state.isSearch;
        this.isLogin = state.isLogin;
        this.isLoginShow = state.isLoginShow;
        this.backgroundColor = state.backgroundColor;
        this.themeColor = state.themeColor;
        this.isHeaderVisible = state.isHeaderVisible;
        this.backBtnDetails = state.backBtnDetails;
        this.isAtProfile = state.isAtProfile;
        this.profilePageUser = state.profilePageUser;
        this.updateRouteBasedFlags();
        if (state.reTriggerNeeded) {
          this.runInitialFunctions();
        }
        if (state.top) {
          this.top = state.top;
        }
      });
    if (!this.commonService.isWhiteLabelWeb) {
      this.isWhiteLabelDataLoading = false;
    } else {
      // For white label sites, check if data is already available to prevent flickering
      this.isWhiteLabelDataLoading = !this.cs.isWhiteLabelWeb;
    }
    this.walletService.walletCountUpdate
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res) {
          this.userNotifications();
        }
      });
    this.marketingPageStateService.isMarketingPageVisible$
      .pipe(takeUntil(this.destroy$))
      .subscribe((visible) => {
        this.isMarketingPageVisible = visible;
      });
    this.marketingPageStateService.isPromotionalHome$
      .pipe(takeUntil(this.destroy$))
      .subscribe((visible) => {
        this.isPromotionalHome = visible;
      });
    this.marketingPageStateService.isMarketingProPage$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isProPage) => {
        this.isAtProPage = isProPage;
      });

    this.loadMarketingListingPages();
    this.loadMarketingProListingPages();
    this.loadComparisonListingPages();
  }
  loadMarketingListingPages(): void {
    const prefetchedData = MARKETING_PAGE_DATA['home'];
    if (prefetchedData) {
      this.processMarketingListingData(prefetchedData);
      return;
    }

    this.apiCacheService
      .get(
        `${API_URLS.marketingPage}?url=home&include_sections=true`,
        CacheTypes.PRERENDERED
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.processMarketingListingData(res);
        }
      });
  }

  private processMarketingListingData(res: any): void {
    if (res.data?.sections?.length) {
      const featuresSection = res.data.sections.find(
        (section) => section.layout_id === 'vertical-card-carousel-layout'
      );
      const verticalCards = featuresSection?.vertical_cards;

      if (verticalCards?.length) {
        this.cs.marketingPagesRoutes = verticalCards
          .filter(
            (card: { redirection_link: string }) => card.redirection_link
          )
          .map(
            (card: { redirection_link: string }) => card.redirection_link
          );
        this.PAGE_FEATURES = verticalCards.map((card) => ({
          imageUrl: card.image,
          title: card.heading,
          redirectUrl: card.redirection_link
        }));
      }
    }
  }

  loadMarketingProListingPages(): void {
    if (Object.keys(MARKETING_PRO_PAGE_DATA).length > 0) {
      this.processMarketingProListingData(MARKETING_PRO_PAGE_DATA);
      return;
    }

    this.apiCacheService
      .get(
        `${API_URLS.marketingPage}?limit=50&type=MARKETING_PRO`,
        CacheTypes.PRERENDERED
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.processMarketingProListingData(res);
        }
      });
  }

  private processMarketingProListingData(source: any): void {
    const routes = this.resolveMarketingProRoutes(source);
    if (routes.length) {
      this.cs.marketingProPagesRoutes = routes;
    }
  }

  private resolveMarketingProRoutes(source: any): string[] {
    if (source && typeof source === 'object' && !Array.isArray(source?.data)) {
      return Object.values(source)
        .filter((entry: any) => entry?.data?.url)
        .map((entry: any) => `/${entry.data.url.replace(/\/$/, '')}`);
    }

    if (source?.data && Array.isArray(source.data)) {
      return source.data
        .filter((page: any) => page?.url)
        .map((page: any) => `/${page.url.replace(/\/$/, '')}`);
    }

    return [];
  }

  loadComparisonListingPages(): void {
    if (Object.keys(COMPARISON_PAGE_DATA).length > 0) {
      this.processComparisonListingData(COMPARISON_PAGE_DATA);
      return;
    }

    this.apiCacheService
      .get(
        `${API_URLS.marketingPage}?limit=50&type=MARKETING_COMPARISON`,
        CacheTypes.PRERENDERED
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.processComparisonListingData(res);
        }
      });
  }

  private processComparisonListingData(source: any): void {
    const comparisons = this.resolveComparisonListingItems(source);
    if (comparisons.length) {
      this.PAGE_COMPARISONS = comparisons;
    }
  }

  private resolveComparisonListingItems(
    source: any
  ): Array<{ competitor_logo: string; redirectUrl: string }> {
    if (source && typeof source === 'object' && !Array.isArray(source?.data)) {
      const prefetchedPages = Object.values(source).filter(
        (entry: any) => entry?.data?.url
      );
      if (prefetchedPages.length) {
        return prefetchedPages
          .sort(
            (a: any, b: any) =>
              (a?.data?.sequence_number ?? Application.ZERO) - (b?.data?.sequence_number ?? Application.ZERO)
          )
          .map((entry: any) => this.mapComparisonPageToListingItem(entry.data))
          .filter(
            (
              item
            ): item is {
              competitor_logo: string;
              redirectUrl: string;
            } => item !== null
          );
      }
    }

    if (Array.isArray(source?.data)) {
      return [...source.data]
        .sort(
          (a: any, b: any) =>
            (a?.sequence_number ?? Application.ZERO) - (b?.sequence_number ?? Application.ZERO)
        )
        .map((page: any) => this.mapComparisonPageToListingItem(page))
        .filter(
          (
            item
          ): item is {
            competitor_logo: string;
            redirectUrl: string;
          } => item !== null
        );
    }

    if (source?.data?.url) {
      const item = this.mapComparisonPageToListingItem(source.data);
      return item ? [item] : [];
    }

    return [];
  }

  private mapComparisonPageToListingItem(
    page: any
  ): { competitor_logo: string; redirectUrl: string } | null {
    const redirectUrl = page?.url?.trim();
    const competitorLogo = page?.competitor_logo?.trim();

    if (
      !redirectUrl ||
      !competitorLogo ||
      page?.status?.toUpperCase() !== Application.PUBLISHED?.toUpperCase()
    ) {
      return null;
    }

    return {
      competitor_logo: competitorLogo,
      redirectUrl
    };
  }

  onHeaderOpen(isOpened: boolean): void {
    this.isHeaderOpen = isOpened;
  }

  setUserOnline() {
    if (this.userProfileData?.email) {
      this.chatService.makeConnection();
      this.chatService.connect();
      this.chatService.setChatEmail(
        this.userProfileData?.email,
        this.userProfileData?.gsi4pk
      );
    }
  }

  fetchUserBlockedList(): void {
    if (!this.authService.isAuthenticated()) return;
    this.acs.get(API_URLS.blockListEmail, false).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.userBlockList = res.data;
        } else {
          this.userBlockList = [];
        }
      },
      error: () => {
        this.userBlockList = [];
      }
    });
  }

  ngAfterViewInit() { }

  onMouse() {
    this.isSearching = false;
  }

  async onRoute(): Promise<void> {
    if (this.authService.isUnAuthorizedUser()) {
      this.router.navigateByUrl(ROUTE_PATHS.CONTENT_PATH);
      return;
    }
    if (!this.authService.isAuthenticated()) {
      this.router.navigateByUrl(ROUTE_PATHS.HOME_PATH);
      this.isAtCreatorHomePage = false;
      this.isAtAdvertisementHomePage = false;
      return;
    }
    const raw = await firstValueFrom(
      this.store.select(fromUserProfile.getUserProfileItems).pipe(take(1))
    );
    const res =
      raw && !Array.isArray(raw) && typeof raw === 'object'
        ? (raw as UserData)
        : null;
    if (res?.admin_approval_status === this.applicationStatusEnums.PENDING) {
      this.router.navigateByUrl(ROUTE_PATHS.EDIT_PREFERENCE_PATH);
      return;
    }
    if (!!environment.whiteLabelConfig) {
      this.cs.navigateToWhiteLabelHome();
      return;
    }
    if (!res) {
      this.router.navigateByUrl(ROUTE_PATHS.DASHBOARD_PATH);
      return;
    }
    const creatorOrApproved =
      !!res.is_creator ||
      res.admin_approval_status === this.applicationStatusEnums.APPROVED;
    if (creatorOrApproved && res.user_name) {
      if (res.is_creator) {
        this.router.navigate([ROUTE_PATHS.EDIT_PREFERENCE_WHITELABEL]);
      } else {
        this.router.navigate([res.user_name]);
      }
      return;
    }
    this.router.navigateByUrl(ROUTE_PATHS.DASHBOARD_PATH);
  }

  addClass() {
    this.renderer.addClass(
      this.el.nativeElement.querySelector('.header'),
      'header-opened'
    );
    this.cs.changeFocussedStatus(true);
    this.searchClass = 'search-active';
  }

  onSearchIconClick(): void {
    this.isSearchBarOpen = !this.isSearchBarOpen;
    this.addClass();
  }

  closeSearch() {
    this.cs.changeFocussedStatus(false);
    this.renderer.removeClass(
      this.el.nativeElement.querySelector('.header'),
      'header-opened'
    );
    this.searchClass = '';
    this.isSearching = false;
    this.isSearchRes = false;
    this.isSearchBarOpen = false;
  }

  isLoggedIn(): boolean {
    if (this.cs.isBrowser) {
      return this.authService?.isAuthenticated();
    } else {
      return false;
    }
  }

  isUnAuthorizedUser(): boolean {
    return this.authService.isUnAuthorizedUser();
  }

  updateProfileTheme(selectedTheme: string): void {
    if (this.isWhitelabel) {
      return;
    }
    this.cs.updateTheme(selectedTheme);
  }

  routerState() {
    this.router.events
      .pipe(
        filter((evt: any) => evt instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe((events: RoutesRecognized[]) => {
        if (
          events[Application.ONE].urlAfterRedirects.includes(
            this.userProfileData?.user_name
          )
        ) {
          if (
            !this.authService.getHistory()?.includes('content') &&
            this.authService.getHistory() && !events[Application.ZERO].urlAfterRedirects?.includes('share')
          ) {
            this.authService.setLocationHistory(
              events[Application.ZERO].urlAfterRedirects
            );
          }
        }
        if (
          events[Application.ZERO].urlAfterRedirects.includes('messages') ||
          events[Application.ZERO].urlAfterRedirects.includes('resources')
        ) {
          this.authService.setLocationHistory(
            events[Application.ZERO].urlAfterRedirects
          );
        }
        this.setOnPageClasses(events[Application.ONE].urlAfterRedirects);
      });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart || event instanceof NavigationEnd) {
        if (event instanceof NavigationEnd) {
          this.userProfile();
        }
        this.isFeaturesDropdownOpen = false;
        this.isCompareDropdownOpen = false;
        this.isMarketingKebabMenuOpen = false;
        this.isVerticalsDropdownOpen = false;
        this.isPlatformDropdownOpen = false;
        this.updateBodyScroll();
        this.updateRouteBasedFlags();
        this.setOnPageClasses(event.url);
      }
    });
  }

  setOnPageClasses(url) {
    if (url.includes(Application.home)) {
      this.mobileHideClass = '';
      this.lineRemoveClass = '';
      this.headerWithoutLogin = '';
      this.isActionButton.next(false);
    } else if (url === Application.dashboard) {
      this.mobileHideClass = 'header-noborder';
      this.lineRemoveClass = '';
      this.headerWithoutLogin = '';
      this.isActionButton.next(true);
    } else if (this.isAtHomePage || this.isAtCreatorHomePage) {
      this.headerWithoutLogin = '';
      this.lineRemoveClass = 'header-no-border';
      this.mobileHideClass = '';
      this.isActionButton.next(true);
    } else {
      this.headerWithoutLogin = '';
      this.lineRemoveClass = '';
      this.mobileHideClass = '';
      this.isActionButton.next(true);
    }
  }

  getFollowers() {
    if (!this.authService.isAuthenticated()) return;
    this.acs.get(API_URLS.getSavedAndFollower, false).subscribe({
      next: (res) => {
        if (res.status) {
          this.store.dispatch(new userProfileAction.SetFollowers(res.data));
        } else {
          this.cs.showErrorMessage(res.message);
        }
      },
      error: (err) => {
        this.cs.showErrorMessage(err.message);
      }
    });
  }

  userProfile() {
    if (!this.authService.isAuthenticated()) return;
    this.acs
      .get(
        `${API_URLS.users}?host_name=${this.cs.isBrowser ? window.location.origin : null}`,
        false
      )
      .subscribe({
        next: (res) => {
          if (res.status) {
            if (res.is_suspended) {
              this.authService.removeDetails();
              this.router.navigate(['auth/login']);
              return;
            }
            const mergeObj = {
              ...res.creator_detail,
              ...res.data,
              is_white_label: res.is_white_label,
              is_host_owner: res.is_host_owner,
              delegate_user: res.delegate_user
            };
            this.userProfileData = mergeObj;
            this.userProfileData.isAbove18 = this.cs.isUser18Above(
              this.userProfileData.birth_date
            );
            this.authService.userData = mergeObj;
            this.authService.setIsCreator(!!mergeObj.is_creator);
            this.headerFooterStateService.emitUserData(mergeObj);
            this.store.dispatch(new userProfileAction.SetUserProfile(mergeObj));
            const savedTheme = this.cs.getValueFromLocalStorage('theme');
            const theme = savedTheme ? savedTheme : Application.THEME_DARK;
            this.currentTheme = res.data.profile_theme || theme || Application.THEME_DARK;
            if (!this.userProfileData?.is_white_label) {
              this.updateProfileTheme(res.data.profile_theme || theme);
            }
            this.setUserOnline();
            if (!this.isAdminAccess)
              this.firebaseService.requestFirebaseToken();
          } else {
            this.updateProfileTheme(Application.THEME_DARK);
            this.cs.showErrorMessage(res.message);
          }
        },
        error: (err) => {
          this.updateProfileTheme(Application.THEME_DARK);
          if (err?.message !== Application.UNAUTHORIZED) {
            this.cs.showErrorMessage(err.message);
          }
        }
      });
  }

  checkRefreshToken() {
    if (this.authService.isTokenExpire()) {
      return this.refreshToken();
    } else {
      return false;
    }
  }

  refreshToken() {
    const refreshToken = this.cs.isBrowser ? (JSON.parse(localStorage.getItem(Application.REFRESH_TOKEN)) || this.indexedDbService.getValueFromIndexedDb(Application.REFRESH_TOKEN)) : {};
    if (refreshToken) {
      this.acs
        .put(
          API_URLS.refreshToken,
          { refreshToken: refreshToken.fm_over },
          false
        )
        .subscribe({
          next: (res) => {
            if (res.status) {
              const user = { fm_user: res.token };
              this.authService.changeToken(user);
            } else {
              this.cs.showErrorMessage(res.message);
              this.navigateToLogin()
            }
          },
          error: (err) => {
            this.cs.showErrorMessage(err.message);
            this.navigateToLogin()
          }
        });
    }
  }

  userNotifications() {
    if (!this.authService.isAuthenticated()) return;
    let url = `${API_URLS.Notification}?is_white_label=false&hostName=null`;
    if (this.whiteLabelConfig) {
      url = `${API_URLS.Notification}?is_white_label=true&hostName=${this.cs.getHostUrl}`;
    }
    const sub = this.acs.get(url, false).subscribe({
      next: (res) => {
        if (res.status) {
          this.store.dispatch(new userProfileAction.SetRefreshKey(res.data));
        }
      },
      error: (error) => {
        console.error('Error in userNotifications:', error);
      }
    });
    this.subscriptionList.push(sub);
  }

  navigateToSignup() {
    if (this.cs.isWhiteLabelWeb) {
      this.router.navigate(['/auth/signup']);
    } else {
      this.userTypeSelectionModal?.openModal();
      // this.router.navigate(['/creators'], { queryParams: { apply_now: 'true' } });
    }
  }

  @HostListener('document:click', ['$event'])
  @HostListener('document:touchstart', ['$event'])
  hideDropdown(event): void {
    if (this.cs.isBrowser) {
      const target = event?.target as HTMLElement;
      const isKebabInteraction = !!target?.closest?.('.marketing-kebab-wrapper');
      const isDropdownTrigger = !!target?.closest?.(
        '.features-toggle-btn, .marketing-kebab-menu__item, .features-dropdown-panel'
      );

      if (!isKebabInteraction) {
        this.isMarketingKebabMenuOpen = false;
        this.updateBodyScroll();
      }

      const isProDropdownTrigger = !!target?.closest?.(
        '.pro-dropdown-wrapper, .pro-dropdown-panel'
      );

      if (!isDropdownTrigger && !isProDropdownTrigger && !this.el.nativeElement.contains(event?.target)) {
        this.isFeaturesDropdownOpen = false;
        this.isCompareDropdownOpen = false;
        this.isVerticalsDropdownOpen = false;
        this.isPlatformDropdownOpen = false;
        this.updateBodyScroll();
      }
    }
    if (
      this.cs.isBrowser &&
      !this.el.nativeElement.contains(event?.target) &&
      !event?.target?.outerHTML?.includes('<em>✕</em>') &&
      this.isSearchBarOpen
    ) {
      if (this.el.nativeElement.querySelector('.header')) {
        this.renderer.removeClass(
          this.el.nativeElement.querySelector('.header'),
          'header-opened'
        );
      }
      if (this.el.nativeElement.querySelector('.dropdown-menu')) {
        this.renderer.removeClass(
          this.el.nativeElement.querySelector('.dropdown-menu'),
          'show'
        );
      }
    }
  }

  getMessageCount() {
    const sub = this.coreService.messageCount.subscribe((res: any) => {
      this.messageCount = res ? this.cs.kFormatter(res) : '';
    });
    this.subscriptionList.push(sub);
  }

  ngOnDestroy(): void {
    this.top = null;
    this.isFeaturesDropdownOpen = false;
    this.isCompareDropdownOpen = false;
    this.isMarketingKebabMenuOpen = false;
    this.isVerticalsDropdownOpen = false;
    this.isPlatformDropdownOpen = false;
    this.updateBodyScroll();
    this.headerStateSubscription?.unsubscribe();
    this.subscriptionList.forEach((sub) => sub?.unsubscribe());
    clearInterval(this.intervalItem);
    this.destroy$.next();
    this.destroy$.complete();
  }

  navigateToCreators() {
    this.router.navigate(['/creators']);
    this.isAtCreatorHomePage = true;
  }

  applyToJoin() {
    this.creatorsRequirementModal?.openModal();
  }

  closeModal() {
    this.creatorsRequirementModal?.closeModal();
  }

  bookDemo() {
    this.modalRef = this.modalService.show(this.bookDemoModal);
  }

  navigateToRequestADemo(): void {
    this.router.navigate(['/' + ROUTE_PATHS.REQUEST_DEMO]);
  }

  toggleFeaturesDropdown(event?: Event): void {
    event?.stopPropagation();
    this.isFeaturesDropdownOpen = !this.isFeaturesDropdownOpen;
    if (this.isFeaturesDropdownOpen) {
      this.isCompareDropdownOpen = false;
      this.isVerticalsDropdownOpen = false;
      this.isPlatformDropdownOpen = false;
    }
    this.isMarketingKebabMenuOpen = false;
    this.updateBodyScroll();
  }

  closeFeaturesDropdown(clickedItem: any): void {
    this.isFeaturesDropdownOpen = false;
    this.updateBodyScroll();
    if(clickedItem?.redirectUrl) this.router.navigate([`/${clickedItem?.redirectUrl}`]);
  }

  toggleCompareDropdown(event?: Event): void {
    event?.stopPropagation();
    this.isCompareDropdownOpen = !this.isCompareDropdownOpen;
    if (this.isCompareDropdownOpen) {
      this.isFeaturesDropdownOpen = false;
      this.isVerticalsDropdownOpen = false;
      this.isPlatformDropdownOpen = false;
    }
    this.isMarketingKebabMenuOpen = false;
    this.updateBodyScroll();
  }

  toggleMarketingKebabMenu(event: Event): void {
    event.stopPropagation();
    this.isMarketingKebabMenuOpen = !this.isMarketingKebabMenuOpen;
    if (this.isMarketingKebabMenuOpen) {
      this.isFeaturesDropdownOpen = false;
      this.isCompareDropdownOpen = false;
      this.isVerticalsDropdownOpen = false;
      this.isPlatformDropdownOpen = false;
    }
    this.updateBodyScroll();
  }

  closeMarketingKebabMenu(): void {
    this.isMarketingKebabMenuOpen = false;
    this.updateBodyScroll();
  }

  openFeaturesFromKebab(event: Event): void {
    event.stopPropagation();
    this.isMarketingKebabMenuOpen = false;
    this.isCompareDropdownOpen = false;
    this.isFeaturesDropdownOpen = true;
    this.updateBodyScroll();
  }

  openCompareFromKebab(event: Event): void {
    event.stopPropagation();
    this.isMarketingKebabMenuOpen = false;
    this.isFeaturesDropdownOpen = false;
    this.isCompareDropdownOpen = true;
    this.updateBodyScroll();
  }

  closeCompareDropdown(clickedItem: any): void {
    this.isCompareDropdownOpen = false;
    this.updateBodyScroll();
    if (clickedItem?.redirectUrl) this.router.navigate([`/${clickedItem?.redirectUrl}`]);
  }

  toggleVerticalsDropdown(event?: Event): void {
    event?.stopPropagation();
    this.isVerticalsDropdownOpen = !this.isVerticalsDropdownOpen;
    if (this.isVerticalsDropdownOpen) {
      this.isFeaturesDropdownOpen = false;
      this.isCompareDropdownOpen = false;
      this.isPlatformDropdownOpen = false;
    }
    this.isMarketingKebabMenuOpen = false;
    this.updateBodyScroll();
  }

  navigateProDropdown(route: string): void {
    this.isVerticalsDropdownOpen = false;
    this.isPlatformDropdownOpen = false;
    this.isMarketingKebabMenuOpen = false;
    this.updateBodyScroll();
    this.router.navigate([route]);
  }

  private updateBodyScroll(): void {
    if (this.cs.isBrowser) {
      const anyOpen = this.isFeaturesDropdownOpen || this.isCompareDropdownOpen
        || this.isMarketingKebabMenuOpen || this.isVerticalsDropdownOpen || this.isPlatformDropdownOpen;
      if (anyOpen) {
        this.renderer.addClass(this.document.documentElement, 'features-dropdown-open');
      } else {
        this.renderer.removeClass(this.document.documentElement, 'features-dropdown-open');
      }
    }
  }

  closeBookDemoModal() {
    this.modalRef.hide();
  }

  navigateToLogin() {
    if (this.cs.isWhiteLabelWeb) {
      const username = this.cs.whiteLabelData?.user?.user_name;
      this.router.navigate([`/${username}`]);
      return;
    }
    this.router.navigate(['/']);
  }

  navigateToLiveStream() {
    if(this.userProfileData?.is_live && this.userProfileData?.livestream_id && this.userProfileData?.user_name) {
      this.router.navigate([`dashboard/live-stream/${this.userProfileData?.user_name}/${this.userProfileData?.livestream_id}`]);
    } else {
      this.router.navigate(['/dashboard/live-stream']);
    }
  }

  navigateToAdvertiseRegister(): void {
    const registerUrl = `${environment.advertiseUrl}auth/register`;
    if (this.cs.isBrowser) {
      window.open(registerUrl, '_blank');
    }
  }

  navigateToAdvertiseLogin(): void {
    const loginUrl = `${environment.advertiseUrl}auth/login`;
    if (this.cs.isBrowser) {
      window.open(loginUrl, '_blank');
    }
  }

  get isAtWLSHomePage() {
    const path = this.router.url?.split('?')[0]?.split('#')[0] ?? '';
    return path === '/' && !!environment.whiteLabelConfig;
  }

  get showMySiteLabel() {
    return (
      this.authService.isLogin &&
      this.whiteLabelConfig &&
      this.whitelabelUserData?.gsi4pk === this.userProfileData?.gsi4pk &&
      this.isAtProfile &&
      this.profilePageUser?.gsi4pk === this.userProfileData?.gsi4pk &&
      this.scrSize <= this.screenSize.mobile &&
      !this.isAtWLSHomePage
    );
  }

  get topFanLogoFallbackUrl(): string {
    if (this.isAtProHomePage) {
      return TOPFAN_HEADER_DEFAULT_LOGO_URLS.PRO_PAGE;
    }
    return this.isPromotionalHome
      ? TOPFAN_HEADER_DEFAULT_LOGO_URLS.MARKETING_HOME_FALLBACK
      : TOPFAN_HEADER_DEFAULT_LOGO_URLS.DEFAULT;
  }

  get topFanDarkLogoFallbackUrl(): string {
    if (this.isAtProHomePage) {
      return TOPFAN_HEADER_DEFAULT_LOGO_URLS.PRO_PAGE;
    }
    return TOPFAN_HEADER_DEFAULT_LOGO_URLS.MARKETING_HOME_FALLBACK;
  }

  get showWhiteLabelTextLogo(): boolean {
    return !!this.whiteLabelConfig && !this.whiteLabelConfig.logo_url;
  }
}
